import { useEffect, useRef } from 'react';

// 프리셋 그라디언트/색 (CSS background 문자열로 저장)
export const COVER_PRESETS = [
  'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  'linear-gradient(135deg, #2383e2 0%, #1abc9c 100%)',
  'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
  'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
  'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
  'linear-gradient(135deg, #0f9d58 0%, #a8e063 100%)',
  'linear-gradient(135deg, #e0561d 0%, #f4b400 100%)',
  'linear-gradient(135deg, #434343 0%, #000000 100%)',
];

export default function CoverPicker({ value, onSelect, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    function onDoc(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    function onKey(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('mousedown', onDoc);
    window.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div className="pe-popover pe-cover-popover" ref={ref} role="dialog" aria-label="커버 선택">
      <div className="pe-popover-head">
        <span className="pe-popover-title">커버 선택</span>
        {value ? (
          <button type="button" className="pe-popover-clear" onClick={() => onSelect(null)}>
            제거
          </button>
        ) : null}
      </div>
      <div className="pe-cover-grid">
        {COVER_PRESETS.map((g) => (
          <button
            key={g}
            type="button"
            className={`pe-cover-swatch${g === value ? ' is-active' : ''}`}
            style={{ background: g }}
            onClick={() => onSelect(g)}
            aria-label="커버 프리셋"
          />
        ))}
      </div>
    </div>
  );
}
